module.exports = __webpack_public_path__ + "static/img/dentaire-03.1c815ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dentaire-03.png
// module id = 83
// module chunks = 0